import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { superAdminApi } from '../api/superAdminApi';

export function useSuperAdminAdmins(params) {
  return useQuery({
    queryKey: ['superadmin', 'admins', params],
    queryFn: () => superAdminApi.getAdmins(params),
    keepPreviousData: true,
  });
}

export function useSuperAdminAdmin(adminId) {
  return useQuery({
    queryKey: ['superadmin', 'admins', adminId],
    queryFn: () => superAdminApi.getAdmin(adminId),
    enabled: !!adminId,
  });
}

export function useCreateAdmin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (adminData) => superAdminApi.createAdmin(adminData),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'admins'] }),
  });
}

export function useUpdateAdmin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ adminId, adminData }) => superAdminApi.updateAdmin(adminId, adminData),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'admins'] }),
  });
}

export function useDeleteAdmin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (adminId) => superAdminApi.deleteAdmin(adminId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'admins'] }),
  });
}

export function useUpdateAdminVerification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ adminId, isVerified }) => superAdminApi.updateAdminVerification(adminId, isVerified),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'admins'] }),
  });
}

export function useUpdateAdminCommission() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ adminId, commissionRate }) => superAdminApi.updateAdminCommission(adminId, commissionRate),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['superadmin', 'admins'] }),
  });
}